import {
  PresentationChartBarIcon,
  UserGroupIcon,
  PhotographIcon,
  CollectionIcon,
} from '@heroicons/react/outline';

import { Routes } from 'constants/routes';
import { Roles } from 'constants/roles';

export const MENU_ITEMS = [
  {
    name: 'dashboard',
    icon: PresentationChartBarIcon,
    text: 'Dashboard',
    route: Routes.Dashboard,
    availableForRoles: [Roles.Admin, Roles.Artist],
  },
  {
    name: 'employees',
    icon: UserGroupIcon,
    text: 'Employees',
    route: Routes.Datasets,
    availableForRoles: [Roles.Admin, Roles.HrManager],
  },
  {
    name: 'arts',
    icon: PhotographIcon,
    text: 'Artworks',
    route: Routes.Arts.Base,
    availableForRoles: [Roles.Admin, Roles.Artist, Roles.Moderator],
  },
  {
    name: 'widgets',
    icon: CollectionIcon,
    text: 'Widgets',
    route: Routes.Widgets.Base,
    availableForRoles: [Roles.Artist],
  },
];
